//Texture constants
//TODO: Which of these do I need (since I only use textures to display label sprites) ?
export enum TextureOperations {
  MultiplyOperation = 0,
  MixOperation = 1,
  AddOperation = 2,
}